module.exports = __webpack_public_path__ + "static/media/unlock-alt.647cdfe6.svg";